import { Metric } from '@strength/domain';
import { useMetrics } from '../../../../../hooks/useMetrics';
import { ActualsIncrementInput } from './IncrementInput';
import { RepInput } from './RepInput';
import { BaseMetricInputProps } from './types';
import { UneditableInput } from './UneditableInput';
import { UnitInput } from './UnitInput';
import { WeightInput } from './WeightInput';

export const TabletActualsMetricInput = ({
  libraryExerciseId,
  workoutSetId,
  setMetric,
  exerciseMetric,
  orgMetric,
  originalSetMetric,
  onEditSetMetric,
  disabled,
}: {
  libraryExerciseId: string;
  orgMetric: Metric;
  disabled?: boolean;
} & BaseMetricInputProps) => {
  const { getMetric } = useMetrics();
  const metric = getMetric(setMetric.metricId);
  // For now, we treat keyword only metrics as non-collectable
  if (!orgMetric.isCollectable || metric.config.numericType === 'none') {
    return <UneditableInput setMetric={setMetric} />;
  }

  switch (metric.type) {
    case 'intensity':
      return (
        <WeightInput
          libraryExerciseId={libraryExerciseId}
          workoutSetId={workoutSetId}
          setMetric={setMetric}
          originalSetMetric={originalSetMetric}
          exerciseMetric={exerciseMetric}
          onEditSetMetric={onEditSetMetric}
          disabled={disabled}
        />
      );
    case 'rpe':
      return (
        <ActualsIncrementInput
          workoutSetId={workoutSetId}
          setMetric={setMetric}
          originalSetMetric={originalSetMetric}
          exerciseMetric={exerciseMetric}
          onEditSetMetric={onEditSetMetric}
          increment={0.5}
          min={1}
          max={10}
          disabled={disabled}
        />
      );
    case 'reps':
      return (
        <RepInput
          workoutSetId={workoutSetId}
          setMetric={setMetric}
          originalSetMetric={originalSetMetric}
          exerciseMetric={exerciseMetric}
          onEditSetMetric={onEditSetMetric}
          disabled={disabled}
        />
      );
    default:
      if (
        metric.config.numericType === 'integer' &&
        !metric.config.units.length
      ) {
        // This implementation would only show increment buttons if there are no units
        return (
          <ActualsIncrementInput
            workoutSetId={workoutSetId}
            setMetric={setMetric}
            originalSetMetric={originalSetMetric}
            exerciseMetric={exerciseMetric}
            onEditSetMetric={onEditSetMetric}
            increment={1}
            min={0}
            disabled={disabled}
          />
        );
      }
      return (
        <UnitInput
          libraryExerciseId={libraryExerciseId}
          workoutSetId={workoutSetId}
          setMetric={setMetric}
          originalSetMetric={originalSetMetric}
          exerciseMetric={exerciseMetric}
          onEditSetMetric={onEditSetMetric}
          disabled={disabled}
        />
      );
  }
};
